import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { GameSystem } from '../../types';
import { gameDefinitions } from '../../game/gameDefinitions';

interface GameSystemSelectorProps {
  value: GameSystem;
  onChange: (gameSystem: GameSystem) => void;
  fullWidth?: boolean;
}

export const GameSystemSelector: React.FC<GameSystemSelectorProps> = ({
  value,
  onChange,
  fullWidth = false,
}) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    fullWidth={fullWidth}
    size="small"
    aria-label="Game system"
    onChange={(_, nextValue: GameSystem | null) => {
      if (nextValue) onChange(nextValue);
    }}
  >
    {(Object.keys(gameDefinitions) as GameSystem[]).map((gameSystem) => (
      <ToggleButton key={gameSystem} value={gameSystem} aria-label={gameDefinitions[gameSystem].name}>
        {gameDefinitions[gameSystem].name}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);